$(() => {
    if (!WebPageObj.search) return;
    
    // Handle hash-based product loading
    if (window.location.hash) {
        const hash = window.location.hash.substring(1);
        const [prefix, action, offset] = hash.split('/');
        
        if (prefix === '!' && action === 'show' && offset && /[0-9]{2,}/.test(offset)) {
            const $showMoreProducts = $('#show-more-products');
            $showMoreProducts.parent().parent().find('.show-more-link').hide();
            $showMoreProducts.parent().parent().find('.show-more-loader').show();
            
            $('#product-load-holder').load(`/search/reload/20/${offset}`, function() {
                $('.show-more-box').replaceWith($('#product-load-holder').html());
                $('#product-load-holder').html('');
                $("html, body").animate({scrollTop: $(`#prod-${offset}`).offset().top + 'px'}, 0);
            });
        }
    }

    // Show more products click handler
    $(document).on('click', '#show-more-products', function(e) {
        e.preventDefault();
        
        const $this = $(this);
        $this.parent().parent().find('.show-more-link').hide();
        $this.parent().parent().find('.show-more-loader').show();
        
        const params = $this.attr('data-cat').replace('subcat-', '').split('-');
        
        $('#product-load-holder').load(`/search/reload/${params[1]}`, function() {
            $('.show-more-box').replaceWith($('#product-load-holder').html());
            $('#product-load-holder').html('');
            window.location.hash = `!/show/${params[1]}`;
        });
        
        return false;
    });

    // Sympathy item click handler
    $('.sympathy-item.active').on('click', function(e) {
        e.preventDefault();
        
        $('#sympathy-items').find('.sympathy-item').each(function() {
            if (!$(this).hasClass('active')) {
                $(this).toggle();
            }
        });
        
        return false;
    });

    // Refine form change handler
    $('#refineform').find('input').on('change', function() {
        const params = $('#refineform').attr('class').replace('subcat-', '');
        const $featListing = $('#featproduct-listing');
        
        $featListing.html('').append($('#ajax-loader-banner-big').html());
        $featListing.find('.ajax-loader-banner-big').show();
        
        $.ajax({
            type: "POST",
            url: '/search/reload/0',
            data: $('#refineform').serialize()
        }).done(function(response) {
            $featListing.html(response);
        });
    });

    // Delivery date change handler
    $('#refine-delivery-date').on('change', function() {
        const params = $('#refineform').attr('class').replace('subcat-', '').split('-');
        const $featListing = $('#featproduct-listing');
        const $refineForm = $('#refineform');
        
        $featListing.html('').append($('#ajax-loader-banner-big').html());
        $featListing.find('.ajax-loader-banner-big').show();
        
        $refineForm.append('<input id="date-changed" type="hidden" name="date_changed" value="1" />');
        
        $.ajax({
            type: "POST",
            url: '/search/reload/0',
            data: $refineForm.serialize()
        }).done(function(response) {
            $featListing.html(response);
            $refineForm.find('#date-changed').remove();
        }).fail(function(xhr, ajaxOptions, thrownError) {
            $refineForm.find('#date-changed').remove();
        });
    });
});